module.exports = __webpack_public_path__ + "static/img/4110_phase_function_Paper_Points.99ce06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4110_phase_function_Paper_Points.png
// module id = DC9q
// module chunks = 0